import { RouteConfig } from "vue-router";

import Signin from "~/modules/auth/views/signin";
import ChangePassword from "~/modules/auth/views/change-password";

const routes: RouteConfig[] = [
  { path: "/login",
    name: "login",
    component: Signin,
    props: route => ({
      redirection: route.query?.r ? atob(route.query.r as string) : undefined,
      fromInactivity: Boolean(route.query?.fromInactivity ? parseInt(route.query.fromInactivity as string) : undefined)
    })
  },
  { path: "/lost-password", name: "lost-password", component: ChangePassword },
  { path: "/account-activation", name: "account-activation", component: ChangePassword },
];

export default routes;

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-b9d4d1c8/routes.tsx" });